import { registerLocaleData } from '@angular/common';
import {
  ApplicationRef,
  Component,
  ComponentFactory,
  ComponentFactoryResolver,
  ComponentRef,
  EmbeddedViewRef,
  Injector,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import {
  faArrowLeft,  
  faArrowRight,
  faInfoCircle,
  faUndo,
} from '@fortawesome/free-solid-svg-icons';
import { ConstantsTexte } from 'src/app/immutable/constants-texte';
import localeDe from '@angular/common/locales/de';
import { Region } from 'src/app/data/ws/region.model';
import { Router } from '@angular/router';
import {
  FileType,
  GlobalConstantsRouting,
  GlobalConstantsStorage,
  GlobalConstantsTexte,
  GlobalFunctions,
  InputErrorStateMatcher,
  SessionStorageService, 
} from 'globales-projekt-angular';
import { ApiService } from 'src/app/services/api.service';
import { Oberbegriff } from 'src/app/data/ws/oberbegriff.model';
import { Rubrik } from 'src/app/data/ws/rubrik.model';
import { OberbegriffAkkordeonComponent } from 'src/app/components/blocks/akkordeon/oberbegriff-akkordeon/oberbegriff-akkordeon.component';
import { MatTableDataSource } from '@angular/material/table';
import { UserDatenEingabe } from 'src/app/data/user/user-daten-eingabe.model';
import { UserDatenRubrikMenge } from 'src/app/data/user/user-daten-rubrik-menge.model';
import { LogikCsv } from 'src/app/functions/logik/logik-csv.module';
import { ConstantsStorage } from 'src/app/immutable/constants-storage';
import { Functions } from 'src/app/functions/functions.module';
import { RubrikBmel } from 'src/app/data/ws/rubrik-bmel';
import { MatDialog } from '@angular/material/dialog';
import { NutzungsbedingungenComponent } from 'src/app/components/blocks/nutzungsbedingungen/nutzungsbedingungen.component';
import { FormControl } from '@angular/forms';

registerLocaleData(localeDe);

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css'],
})
export class MainComponent implements OnInit {
  [x: string]: any;
  anwendungsname: string = ConstantsTexte.ANWENDUNGSNAME;
  showWaitingForDataSpinner: number = 0;

  regionen: Region[];
  rubriken: Rubrik[];
  oberbegriffe: Oberbegriff[];
  refChildAkkordeon: ComponentRef<OberbegriffAkkordeonComponent>[] = [];
  filesToUpload: FileList = null;
  logikCsv: LogikCsv = new LogikCsv();
  userDatenEingabe: UserDatenEingabe = new UserDatenEingabe();
  userDatenEingabeCsv: UserDatenEingabe[] = [];

  faInfoCircle = faInfoCircle;
  faArrowLeft = faArrowLeft;
  faArrowRight = faArrowRight;
  faUndo = faUndo;

  fileName: string;
  csvInhalt: string[][];
  selected: FormControl = new FormControl(0);
  matcher: InputErrorStateMatcher = new InputErrorStateMatcher();
  bezeichnungFormControl: FormControl = new FormControl('');
  regionFormControl: FormControl = new FormControl('');

  isZumErgebnisDisabled: boolean = true;

  isZumErgebnisDatenDisabled: boolean = true;
  isZumErgebnisCSVDisabled: boolean = true;

  hatLizenvereinbarungAkzeptiert: Boolean = null;

  @ViewChild(MatTabGroup) tabGroup: MatTabGroup;

  constructor(
    private apiService: ApiService, 
    private cfr: ComponentFactoryResolver,
    private injector: Injector,
    private appRef: ApplicationRef,
    private dialog: MatDialog,
    private router: Router
  ) {}

  ngOnInit(): void {


    this.hatLizenvereinbarungAkzeptiert = SessionStorageService.getItem(
      GlobalConstantsStorage.HAT_NUTZUNGSBEDINGUNGEN_AKZEPTIERT
    );

    if (this.hatLizenvereinbarungAkzeptiert != true) {
  this.onClickZuEinverstaendniserklaerung();
  
    } else {
      if (this.hatLizenvereinbarungAkzeptiert) {
        this.getRubriken();
        this.getOberbegriffe();
        this.getRegionen();
        this.getBMELCodes();
        this.fileName =
          GlobalConstantsTexte.FILE_UPLOAD_KEINE_AUSWAHL_MEHRERE_DATEIEN;

        this.regionFormControl.markAsTouched();
        this.bezeichnungFormControl.markAsTouched();
      }
    }
  }

  getRubriken() {
    this.showWaitingForDataSpinner++;

    this.apiService.getRubriken().subscribe((response) => {
      this.rubriken = response;

      if (this.oberbegriffe != null && this.rubriken != null) {
        this.createNewAkkordeon(this.oberbegriffe, this.rubriken);

        let userDatenStorrage: UserDatenEingabe[] =
          SessionStorageService.getItem(
            GlobalConstantsStorage.EINGABE_DATEN
          );

        if (userDatenStorrage != null) {
          let isCsvUpload: boolean = SessionStorageService.getItem(
            ConstantsStorage.IS_CSV_UPLOAD
          );

          if (isCsvUpload == false) {
            this.logikCsv = new LogikCsv(
                SessionStorageService.getItem(ConstantsStorage.LOGIK_CSV)
            );
 
            /*
            userDatenStorrage[0].bezeichnung =
              this.logikCsv.getBetriebsnummerDepseudonymisiert(
                userDatenStorrage[0].bezeichnung
              );
              */

              this.bezeichnungFormControl.setValue(this.userDatenEingabe.bezeichnung);

            this.setLastUserDatenEingabe(userDatenStorrage[0]);
          }
        }
      }

      this.showWaitingForDataSpinner--;
    });
  }

  getOberbegriffe() {
    this.showWaitingForDataSpinner++;

    this.apiService.getOberbegriffe().subscribe((response) => {
      this.oberbegriffe = response;
      if (this.oberbegriffe != null && this.rubriken != null) {
        this.createNewAkkordeon(this.oberbegriffe, this.rubriken);

        let userDatenStorrage: UserDatenEingabe[] =
          SessionStorageService.getItem(
            GlobalConstantsStorage.EINGABE_DATEN
          );

        if (userDatenStorrage != null) {
          let isCsvUpload: boolean = SessionStorageService.getItem(
            ConstantsStorage.IS_CSV_UPLOAD
          );

          if (isCsvUpload == false) {
            this.logikCsv = new LogikCsv(
              SessionStorageService.getItem(ConstantsStorage.LOGIK_CSV)
            );


            /*
            userDatenStorrage[0].bezeichnung =
              this.logikCsv.getBetriebsnummerDepseudonymisiert(
                userDatenStorrage[0].bezeichnung
              );*/

              this.bezeichnungFormControl.setValue(this.userDatenEingabe.bezeichnung);

            this.setLastUserDatenEingabe(userDatenStorrage[0]);
          }
        }
      }

      this.showWaitingForDataSpinner--;
    });
  }

  getRegionen() {
    this.showWaitingForDataSpinner++;

    this.apiService.getRegionen().subscribe((response: Region[]) => {
      this.regionen = response;
      this.showWaitingForDataSpinner--;
    });
  }

  getBMELCodes() {
    this.showWaitingForDataSpinner++;

    this.apiService.getBMELCodes().subscribe((response: RubrikBmel[]) => {     
      this.logikCsv.rubrikBmel = response;

      this.showWaitingForDataSpinner--;
    });
  }

  setLastUserDatenEingabe(userDatenEingabe: UserDatenEingabe) {
    this.userDatenEingabe.bezeichnung = userDatenEingabe.bezeichnung;
    this.userDatenEingabe.idRegion = userDatenEingabe.idRegion;

    this.bezeichnungFormControl.setValue(userDatenEingabe.bezeichnung);
    this.regionFormControl.setValue(userDatenEingabe.idRegion);

    userDatenEingabe.userDatenRubrikMenge;

    for (let entry of this.refChildAkkordeon) {
      entry.instance.setLastUserDatenEingabe(
        userDatenEingabe.userDatenRubrikMenge
      );
    }

    this.checkZumErgebnis();
  }

  getPaddingLeft(regionLevel: number): string {
    return GlobalFunctions.getPaddingLeft(regionLevel);
  }

  createNewAkkordeon(
    oberbegriffe: Oberbegriff[],
    rubriken: Rubrik[] // Das überarbeiten, schleufe erzeugen wie bei den ergebnissen und dann sich an das Array hängen!!!!!!!!!!!!!!!!!!!
  ) {
    for (let entry of oberbegriffe) {
      let akkordeonRubrikenLinks: Rubrik[] = [];
      let akkordeonRubrikenRechts: Rubrik[] = [];
      let akkordeonRubriken: Rubrik[] = [];

      for (let entry2 of rubriken) {
        if (entry2.idOberbegriff == entry.idOberbegriff) {
          akkordeonRubriken.push(entry2);
        }
      }

      let i = 0;
      for (let entry3 of akkordeonRubriken) {
        if (akkordeonRubriken.length / 2 <= i)
          akkordeonRubrikenRechts.push(entry3);
        else akkordeonRubrikenLinks.push(entry3);
        i++;
      }

      let oberbegriffAkkordeon: ComponentFactory<OberbegriffAkkordeonComponent> = this.cfr.resolveComponentFactory(OberbegriffAkkordeonComponent);
      let componentRef: ComponentRef<OberbegriffAkkordeonComponent> = oberbegriffAkkordeon.create(this.injector);
      componentRef.instance.oberbegriff = entry;

      componentRef.instance.dataRubrikLinks = new MatTableDataSource(
        akkordeonRubrikenLinks
      );
      componentRef.instance.dataRubrikRechts = new MatTableDataSource(
        akkordeonRubrikenRechts
      );
      componentRef.instance.id = entry.oberbegriff;
      componentRef.instance.parentMainComponent = this;
      componentRef.instance.createErrorFormControl();
      componentRef.instance.clearAllInputFields();

      this.refChildAkkordeon.push(componentRef);

      this.appRef.attachView(componentRef.hostView);
      let domElem: Node = (componentRef.hostView as EmbeddedViewRef<any>)
        .rootNodes[0] as HTMLElement;

      document.getElementById('content_daten').before(domElem);
    }
  }

  getFilesValidFileTypeMsgString(
    fileList: FileList,
    erlaubteExtensions: FileType[],
    erlaubteExtensionsText: FileType[],
    textVorlage: string
  ): string {
    let dateiEndungFalsch: string = '';

    for (let i = 0; i < fileList.length; i++) {
      let file: File = fileList[i];

      if (!GlobalFunctions.checkFileExtension(file, erlaubteExtensions))
        dateiEndungFalsch += '\n' + file.name;
    }

    if (dateiEndungFalsch.length != 0) {
      let endungenString: string = erlaubteExtensionsText[0];

      for (let i = 1; i < erlaubteExtensions.length; i++) {
        endungenString += ', ' + erlaubteExtensionsText[i];
      }

      return (
        GlobalFunctions.replacePlatzhalter(
          textVorlage,
          dateiEndungFalsch,
          endungenString
        ) + '\n'
      );
    }

    return '';
  }

  onClickClearAll() {
    SessionStorageService.clear();

    this.userDatenEingabe.bezeichnung = null;
    this.userDatenEingabe.idRegion = null;

    this.bezeichnungFormControl.setValue(null);
    this.regionFormControl.setValue(null);

    if (this.selected.value == 0) {
      for (let entry of this.refChildAkkordeon) {
        entry.instance.clearAllInputFields();
      }
    } else if (this.selected.value == 1) {
      this.fileName =
        GlobalConstantsTexte.FILE_UPLOAD_KEINE_AUSWAHL_MEHRERE_DATEIEN;
      this.filesToUpload = null;
      this.isZumErgebnisDisabled = true;
    }
  }

  async onFileSelected(event: any) {
    this.filesToUpload = event.target.files;

    // Zuerst schauen ob es Dateien gibt...
    if (this.filesToUpload == null || this.filesToUpload.length == 0) {
      this.onClickClearAll();

      return;
    }

    let erlaubteExtensions: FileType[] = [];
    erlaubteExtensions.push(FileType.CSV_EXT);
    erlaubteExtensions.push(FileType.ZIP_EXT);

    let erlaubteExtensionsText: FileType[] = [];
    erlaubteExtensionsText.push(FileType.CSV_SHORT);
    erlaubteExtensionsText.push(FileType.ZIP_SHORT);

    let msg: string = GlobalFunctions.getFilesValidFileTypeMsgString(
      this.filesToUpload,
      erlaubteExtensions,
      erlaubteExtensionsText,
      ConstantsTexte.KEINE_GUELTIGER_DATEITYP_FUER_DATEI
    );

    if (msg.length != 0) {
      this.onClickClearAll();
      alert(msg);
      return;
    }
    this.showWaitingForDataSpinner++;
    this.csvInhalt = await this.logikCsv.getCsvZipContent(this.filesToUpload);

    if (this.filesToUpload.length > 1)
      this.fileName = GlobalFunctions.replacePlatzhalter(
        GlobalConstantsTexte.FILE_UPLOAD_AUSWAHL_MEHRERE_DATEIEN,
        this.filesToUpload.length.toString()
      );
    else if (this.filesToUpload.length == 0) {
      this.fileName =
        GlobalConstantsTexte.FILE_UPLOAD_KEINE_AUSWAHL_MEHRERE_DATEIEN;
      return;
    } else this.fileName = this.filesToUpload[0].name;

    {
      let sleebExitCounter: number = 0;

      do {
        if (this.csvInhalt != null) {
          this.showWaitingForDataSpinner--;
          break;
        }

        await GlobalFunctions.sleep(250);

        if (sleebExitCounter++ == 10) {
          this.showWaitingForDataSpinner--;
          return;
        }
      } while (true);
    }

    if (this.csvInhalt == null) {
      this.onClickClearAll();
    } else {
      this.isZumErgebnisDisabled = false;
    }
  }

  onClickZuEinverstaendniserklaerung()
  {
    const dialogRef = this.dialog.open(NutzungsbedingungenComponent, {
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.hatLizenvereinbarungAkzeptiert = result;

      SessionStorageService.setItem(
        GlobalConstantsStorage.HAT_NUTZUNGSBEDINGUNGEN_AKZEPTIERT,
        result
      );

      if (result) {
        this.getRubriken();
        this.getOberbegriffe();
        this.getRegionen();
        this.getBMELCodes();
        this.fileName =
          GlobalConstantsTexte.FILE_UPLOAD_KEINE_AUSWAHL_MEHRERE_DATEIEN;

        this.regionFormControl.markAsTouched();
        this.bezeichnungFormControl.markAsTouched();
      }
    });

  }


  onClickZuErgebnisseVorbereitung() {
    let userDatenEingabePost: UserDatenEingabe[] = [];

    if (this.selected.value == 0) {
      for (let entry of this.refChildAkkordeon) {
        let val: UserDatenRubrikMenge[] = entry.instance.getRubrikMenge();

        if (val == null) continue;

        this.userDatenEingabe.userDatenRubrikMenge =
          this.userDatenEingabe.userDatenRubrikMenge.concat(val);
      }

      userDatenEingabePost.push(this.userDatenEingabe);

      SessionStorageService.setItem(ConstantsStorage.IS_CSV_UPLOAD, false);

      this.onClickZuErgebnisse(userDatenEingabePost);
    } else if (this.selected.value == 1) {
      this.showWaitingForDataSpinner++;

      this.apiService
        .postCsvDatenInhalt(this.csvInhalt)
        .subscribe((response) => {
          for (let entry of response) {
            entry.bezeichnung =
              this.logikCsv.getBetriebsnummerDepseudonymisiert(
                entry.bezeichnung
              );
          }

          this.showWaitingForDataSpinner--;

          SessionStorageService.setItem(
            ConstantsStorage.IS_CSV_UPLOAD,
            true
          );
          this.onClickZuErgebnisse(response);
        });
    }
  }

  onClickZuErgebnisse(userDatenEingabePost: UserDatenEingabe[]) {
    for (let entry of userDatenEingabePost) {
      entry.bezeichnung = this.logikCsv.setGetBetriebsnummerPseudonymisiert(
        entry.bezeichnung
      );
    }


    this.showWaitingForDataSpinner++;

    this.apiService
      .postUserBetriebsdaten(userDatenEingabePost)
      .subscribe((response) => {
        for (let entry of response) {
          entry.bezeichnung = this.logikCsv.getBetriebsnummerDepseudonymisiert(
            entry.bezeichnung
          );
        }

        for (let entry of userDatenEingabePost) {
          entry.bezeichnung = this.logikCsv.getBetriebsnummerDepseudonymisiert(
            entry.bezeichnung
          );
        }

        SessionStorageService.setItem(
          ConstantsStorage.LOGIK_CSV,
          this.logikCsv
        );

        SessionStorageService.setItem(
          GlobalConstantsStorage.EINGABE_DATEN,
          new Functions().sortUserEingabe(userDatenEingabePost)
        );

        SessionStorageService.setItem(
          GlobalConstantsStorage.BERECHNUNGSERGEBNISSE,
          new Functions().sortBetriebe(response)
        );

        this.showWaitingForDataSpinner--;

        this.router.navigate([GlobalConstantsRouting.ERGEBNISSE]);
      });
  }

  setBezeichnung(e: any) {
    this.checkZumErgebnis();

    this.userDatenEingabe.bezeichnung = e.target.value;
  }

  setRegion(e: any) {
    this.checkZumErgebnis();

    this.userDatenEingabe.idRegion = Number(e.value);
  }

  checkZumErgebnis() {
    let gefunden: number = 0;

    for (let entry of this.refChildAkkordeon) {
      if (!entry.instance.isFelderGueltig()) {
        this.isZumErgebnisDisabled = true;
      } else {
        let val: UserDatenRubrikMenge[] = entry.instance.getRubrikMenge();

        if (val == null) continue;
        if (val.length == 0) continue;
        gefunden++;
      }
    }

    this.isZumErgebnisDisabled = !(
      gefunden > 0 &&
      this.bezeichnungFormControl.valid &&
      this.regionFormControl.valid
    );
  }

  selectedChange(e: any) {
    this.selected.setValue(e);

    if (this.selected.value == 0) {
      this.isZumErgebnisCSVDisabled = this.isZumErgebnisDisabled;
      this.isZumErgebnisDisabled = this.isZumErgebnisDatenDisabled;
    } else if (this.selected.value == 1) {
      this.isZumErgebnisDatenDisabled = this.isZumErgebnisDisabled;
      this.isZumErgebnisDisabled = this.isZumErgebnisCSVDisabled;
    }
  }
}
